//
//
//
//
//
//
//
//

import utils from './JS/utils'
import ajax from './JS/ajax'
import indexpage from './views/index.vue'

/* eslint-disable */
export default {
  name: 'App',
  components: {
    indexpage
  },
  data() {
    return {
      channel: utils.channel,
      isLoadingMap: false,// 是否加载过定位
      positionStatue: false,// 是否正在定位
      transitionName: "rightMenu",
      windowHeight: window.innerHeight
    }
  },
  /**
   * 创建前 实例初始化之后 不能获得DOM节点
   */
  beforeCreate() {

  },
  /**
   * 创建后 不能获取DOM元素
   */
  created(){

  },
  /**
   * 载入后 数据和DOM都已被渲染出来
   */
  mounted() {
    var that = this;
    window.addEventListener("resize", this.handleResize);
    // 根据域名跳转https
    var domain = document.domain;
    if (domain.indexOf("localhost") == -1) {
      if ((location.protocol != 'https:' || domain.indexOf("www.daoway.com") == -1) && domain.indexOf("daoway.com") != -1) {
        location.href = 'https://www.daoway.com' + location.pathname + location.hash;
      } else if ((location.protocol != 'https:' || domain.indexOf("www.daoway.cn") == -1) && domain.indexOf("daoway.cn") != -1) {
        location.href = 'https://www.daoway.cn' + location.pathname + location.hash;
      }
    }
    var locationurl = this.queryParse(location.href);
    if (locationurl.inviter) {
      localStorage.setItem('inviter', locationurl.inviter);
    }
    if (locationurl.bd_vid) {
      localStorage.setItem('bd_vid', locationurl.bd_vid);
    }
    if (locationurl.qhclickid) {
      localStorage.setItem('qhclickid', locationurl.qhclickid);
    }
  },
  /**
   * 载入前
   */
  beforeMount() {
    console.log(this.$route.path);
  },
  watch: {
    '$route' (to, from) {
      if (!this.isLoadingMap && (to.path == "/" || to.path == "/zhiyue" || to.path == "/search_service")) {
        // 定位判断
        let position = localStorage.getItem("position");
        if (position && position != null) {

        } else {
          if (!this.positionStatue) {
            this.intervalId = setInterval(() => {
              this.$bus.$emit("showload", "");// 开始定位前，每200ms调用一次，防止加载弹窗被关闭
              console.log("定时器");
            }, 200);
            setTimeout(() => {// 如果10秒后没有定位成功，关闭事件并关闭等待窗口
              clearInterval(this.intervalId);// 定位成功后销毁事件
              this.$bus.$emit("hideload", "");// 刷新网页前关闭加载窗口
            }, 10000);
          }
          this.getlocation();
        }
        this.isLoadingMap = true;
      }
      // 删除所有弹窗(切换页面的时候)
      if (from.path != to.path) {
        var chArr = document.getElementsByClassName("dialog-mask");
        for (var i = 0; i < chArr.length; i++) {
          if (chArr[i] != null) {
            chArr[i].parentNode.removeChild(chArr[i]);
          }
        }
      }
      if (from.path == '/' && to.path == '/techniciandetail') {
        this.transitionName = 'index_transition_name';
      }
      if (from.path == '/techniciandetail' && to.path == '/') {
        this.transitionName = 'rightMenu';
      }
      if ((from.path == '/' || from.path == "") && to.path == "/search_service") {// 从主页到项目页
        localStorage.setItem("orderSource", "category");
      } else if (from.path == "/zhiyue" && to.path == "/techniciandetail") {// 从技师列表页到技师详情页
        localStorage.setItem("orderSource", "stafflist");
      } else if (from.path == "/searchComplete" && to.path == "/techniciandetail") {// 从搜索页到技师详情页
        localStorage.setItem("orderSource", "searchtech");
      } else if ((from.path == "/" || from.path == "") && to.path == "/detail") {// 从主页到项目详情页
        localStorage.setItem("orderSource", "category");
      } else if (from.path == "/searchComplete" && to.path == "/detail") {// 从搜索页到项目详情页
        localStorage.setItem("orderSource", "search");
      } else if (to.path == "/allorder" || to.path == "/orderstate") {// 从xxx页到订单页
        localStorage.setItem("orderSource", "reorder");
      } else if (from.path == "/shoppingcar" && to.path == "/reservation") {// 从购物车页到下单页
        localStorage.setItem("orderSource", "cart");
      }
    }
  },
  methods: {
    handleResize() {
      this.windowHeight = window.innerHeight;
    },
    queryParse(url) {
      url = url || window.location.href;
      var obj = {},
        reg = /([^?=&#]+)=([^?=&#]+)/g;
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      return obj;
    },
    // 判断安卓或者ios终端
    ckos() {
      let u = navigator.userAgent
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (isAndroid) {
        return 'android'
      } else if (isiOS) {
        return 'ios'
      } else {
        return 'pc'
      }
    },
    // 判断微信还是其它浏览器
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 使用百度重新定位
     */
    getlocation() {
      var that = this;
      var geolocation = new BMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 10000, //超过3秒后停止定位，默认：无穷大
        maximumAge: 0, //定位结果缓存0毫秒，默认：0
      });
      that.load = true;
      geolocation.getCurrentPosition(
        function (r) { // 成功的回调
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            // alert("定位成功");
            var point = r.point;
            if (r.accuracy !== null) {//查看百度sdk是否返回精准值，来判断用户是否获取了定位权限
              console.log(r.accuracy);
              // alert(r.accuracy)
            } else {
              console.log("The value is null.");
              // alert("The value is null.");
            }
            utils.current = { lng: point.lng, lat: point.lat };
            // console.log("无缓存，定位坐标");
            that.getCommunity(point.lng, point.lat);//查到位接口后加到缓存
          } else {
            // that.ipposition()
            // alert("定位失败");
            clearInterval(this.intervalId);//定位成功后销毁事件
            this.positionStatue = true;//关闭弹窗的持续通知。
            this.$bus.$emit('hideload','');//刷新网页前关闭加载窗口
          }
        },
        function (error) { // 失败的回调
          that.ipposition();
      })
    },
    /**
     * 更新子页变量
     */
    updateVariable(item) {
      if (this.$route.path == "/zhiyue" || this.$route.path == "/search_service") {
        if (this.ckos() == "ios") {// 如果是苹果延迟一秒加载
          window.location.reload();// 定位成功，重新刷新网页
        } else {
          window.location.reload();// 定位成功，重新刷新网页
        }
      }
      if (this.$route.path == "/") {
        this.$bus.$emit('updateVariableEvent', item);
      }
      this.$bus.$emit('hideload', '');// 刷新网页前关闭加载窗口
    },
    /**
     * 根据坐标获取到位返回的位置信息
     */
    getCommunity(lng, lat) {
      var that = this;
      var url = "/daoway/rest/community/autoPositionMerge?lot=" + lng + "&lat=" + lat + "&channel=" + this.channel;
      ajax.get(url, {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      }).then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          var data = result.data;
          var item = [];//返回结果
          var city = "";
          if (data.parent) {
            city = data.parent.city;
            item = data.parent;
          } else if (data.communities && data.communities.length > 0) {
            city = data.communities[0].city;
            item = data.communities[0];
          }
          that.manualCity = city;
          that.community = data.communities;
          that.position = item;// 更新放在列表前
          localStorage.setItem("position", JSON.stringify(item));// 缓存数据
          localStorage.setItem("positionOpen", true);// 在缓存中标记已定位过，下单时会自动带上地址
          this.updateVariable(item);
          clearInterval(this.intervalId);// 定位成功后销毁事件
          this.positionStatue = true;// 定位成功，关闭弹窗的持续通知。
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue